/**
 * This is the entry point for specific javascript of theme
 */


/** WEBPACK FOOTER **
 ** ./js/theme.js
 **/